




import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseCampaignsTableActions from '@/modules/base-campaign/components/shared/table/BaseCampaignsTableActions.vue'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'

@Component({
  components: {
    TesTr
  }
})
export default class BaseCampaignsTableRow extends mixins(TesTableRow) {
  columnComponents = {
    title: {
      component: TextEllipsis,
      handler: value => ({ text: value })
    },
    status: {
      component: CampaignStatusView,
      handler: (value, row) => ({
        status: value,
        statuses: { [value]: row.persian_status }
      })
    },
    running_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value, defaultText: '' })
    },
    actions: {
      component: BaseCampaignsTableActions,
      handler: (value, row) => ({ campaignResource: row })
    }
  }
}
